__turbopack_context__.v({
  "gallery": "product-gallery-module__YGnBlG__gallery",
  "imageSlide": "product-gallery-module__YGnBlG__imageSlide",
  "imagesTrack": "product-gallery-module__YGnBlG__imagesTrack",
  "mainImageContainer": "product-gallery-module__YGnBlG__mainImageContainer",
  "productImage": "product-gallery-module__YGnBlG__productImage",
  "thumbnail": "product-gallery-module__YGnBlG__thumbnail",
  "thumbnailActive": "product-gallery-module__YGnBlG__thumbnailActive",
  "thumbnailImage": "product-gallery-module__YGnBlG__thumbnailImage",
  "thumbnailsWrapper": "product-gallery-module__YGnBlG__thumbnailsWrapper",
});
